import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}

declare let fbq: (...args: any[]) => void;

@Injectable({ providedIn: 'root' })
export class MetaPixelInitializerService {

  private env = environment;

  private pixelId: string | null = null;

  constructor(private http: HttpClient) { }

  init(): Promise<void> {

    // if (!environment.production) {
    //   console.warn('[Meta Pixel] Não inicializado — ambiente de desenvolvimento');
    //   return Promise.resolve();
    // }

    return this.http.get<{ pixelId: string }>(`${this.env.publicApiSocioUrl}v1/socio/meta-pixel`)
      .toPromise()
      .then((response) => {

        if (!response?.pixelId) {
          console.warn('[Meta Pixel] Pixel ID ausente');
          return;
        }

        this.pixelId = response.pixelId;

        return this.loadPixelScript()
          .then(() => this.initializePixel(response.pixelId));
      })
      .catch(err => {
        console.error('[Meta Pixel] Erro ao buscar Pixel ID:', err);
      });
  }

  private loadPixelScript(): Promise<void> {

    return new Promise((resolve, reject) => {

      if (typeof window.fbq === 'function') {
        resolve();
        return;
      }

      const script = document.createElement('script');

      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';

      script.onload = () => resolve();
      script.onerror = () => reject();

      document.head.appendChild(script);
    });
  }

  private initializePixel(pixelId: string): void {

    if (window.fbq) {
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
      return;
    }

    const n: any = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args);
      } else {
        n.queue.push(args);
      }
    };

    n.queue = [];
    n.loaded = true;
    n.version = '2.0';

    window.fbq = n;
    window._fbq = n;

    fbq('init', pixelId);
    fbq('track', 'PageView');

    console.info('[Meta Pixel] Inicializado com ID:', pixelId);
  }

  getPixelId(): string | null {
    return this.pixelId;
  }
}